import React from "react"
import PropTypes from "prop-types"
import { Flex, Typography, Tooltip } from "antd"
import { ArrowUpOutlined, ArrowDownOutlined, InfoCircleOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { buildSlotBlocks } from "../../utils"
import styles from "../../style.module.css"

const { Text } = Typography

export default function BookingAvailabilityWidget({ data, description, title }) {
  const { t } = useTranslation()
  // chart_data for stat: { value, unit, change, details: { booked_slots, total_slots, available_slots } }
  const item = (data && !Array.isArray(data)) ? data : {}
  const bookedSlots = item?.details?.booked_slots ?? 0
  const totalSlots = item?.details?.total_slots ?? 0
  const availableSlots = item?.details?.available_slots ?? 0
  const availabilityPct = item?.value ?? 0
  const pctChange = item?.change ?? 0
  const isDown = pctChange < 0
  const blocks = buildSlotBlocks(totalSlots, bookedSlots)

  return (
    <div className={styles.widgetContent}>
      <Flex justify="space-between" align="center" className={styles.widgetHeader}>
        <Text strong>{title ?? t("ai_dashboard.widget_booking_availability")}</Text>
        {description && (
          <Tooltip title={description} placement="topRight" styles={{ body: { maxWidth: 320 } }}>
            <InfoCircleOutlined className={styles.widgetInfoIcon} />
          </Tooltip>
        )}
      </Flex>
      <div className={styles.bigValue}>{availabilityPct}%</div>
      <Text className={isDown ? styles.trendDown : styles.trendUp}>
        {isDown ? <ArrowDownOutlined /> : <ArrowUpOutlined />} {Math.abs(pctChange)}% {t("ai_dashboard.from_previous_period")}
      </Text>
      <div className={styles.slotSection}>
        <Text type="secondary" className={styles.textSm}>{t("ai_dashboard.slots_total")}</Text>
        <Flex wrap gap={3} className={styles.blockProgress}>
          {blocks.map((filled, i) => (
            <div key={`slot-${i}-${filled ? t("ai_dashboard.booked") : t("ai_dashboard.slot_free")}`} className={`${styles.block} ${filled ? styles.blockFilled : styles.blockEmpty}`} />
          ))}
        </Flex>
        <Flex justify="space-between" className={styles.slotRow}>
          <Text type="secondary" className={styles.textSm}>{bookedSlots} {t("ai_dashboard.booked")}</Text>
          <Text type="secondary" className={styles.textSm}>{availableSlots} {t("ai_dashboard.available")}</Text>
        </Flex>
      </div>
    </div>
  )
}

BookingAvailabilityWidget.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  description: PropTypes.string,
  title: PropTypes.string,
}
